/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import vm from '@/main.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        authenticated: false,
        get userToken() {
            return window.localStorage.getItem('auth')
        },
        set userToken(value) {
            window.localStorage.setItem('auth', value)
        },
        userInfo: {},
        asideWidth: 150,
        activeIndex: '',
        subActiveIndex: ''
    },
    mutations: {
        setAuth(state, auth) {
            state.authenticated = !!auth
            window.localStorage.setItem('auth', auth)
        },
        setUserInfo(state, userInfo) {
            state.userInfo = userInfo
        },
        logout(state) {
            state.authenticated = false
            window.localStorage.setItem('auth', '')
            vm.$router.push('/login')
        },
        setAsideWidth(state, asideWidth) {
            state.asideWidth = asideWidth
        },
        setActiveIndex(state, activeIndex) {
            state.activeIndex = activeIndex
        },
        setSubActiveIndex(state, subActiveIndex) {
            state.subActiveIndex = subActiveIndex
        }
    },
    actions: {},
    modules: {}
})